import HeroSection from '../../sections/HeroSection/HeroSection';
import { ThemeProvider } from 'styled-components';
import theme from '../../global/theme';
import CTASection from '../../sections/CalltoActionSection/CalltoActionSection';
import { GlobalStyle } from '../../global/global';
import {
    Box,
    Flex,
    Text,
    Image,
    UnorderedList,
    ListItem,
    Link,
    List,
    ListIcon,
    Show,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    Button,
    useDisclosure,
    Grid,
    Heading,
    AspectRatio,
} from '@chakra-ui/react';
import FAQ from '../../sections/Faq/Faq';
import ChakraTilesSection from '../../sections/ChakraTilesSection/ChakraTilesSection';
import WhyService from '../../sections/WhyService/WhyService';
import BenefitsSectionWithImage from '../../sections/BenefitsSectionWithImage/BenefitsSectionWithImage';
import ExtendedTabsSection from '../../sections/ExtendedTabsSection/ExtendedTabsSection';
import { CheckIcon, AddIcon, PlusSquareIcon } from '@chakra-ui/icons';
import { ButtonContainer } from '../../sections/MigrationSection/styles';
import StyledButton from '../../components/Button/Button';
import ContactSection from '../../sections/ContactSection/ContactSection';
import ContentImage from '../../sections/ContentImageSection/ContentImageSection';
import FormSection from '../../sections/FormSection/FormSection';
import TilesSection from '../../sections/TilesSection/TilesSection';
import SectionWithPlusTick from '../../sections/SectionWithPlusTick/SectionWithPlusTick';

interface Props {}

const heroImage = {
    url: 'https://www.idosell.com/panel/file-gate.php?id=607798&ext=.jpeg',
    alt: 'Zdjęcie wyróżniające w hero - aplikacje idosell',
};

export default function ABTestsPage(props: Props) {
    return (
        <ThemeProvider theme={theme}>
            <GlobalStyle $whiteColor />
            <HeroSection
                title="Testy A/B w IdoSell to trafne decyzje oparte na danych"
                subTitle="Sprawdzaj, które rozwiązania w Twoim sklepie działają najlepiej i zwiększaj konwersję bez ryzyka. Moduł testów A/B jest w IdoSell dostępny za darmo."
                image={heroImage}
                paddingDesktop="75px 0"
                gap="0"
                ratio="3/4"
                buttons={[
                    {
                        title: 'Włącz testy A/B',
                        href: 'https://pomoc.idosell.com/wyglad-i-konfiguracja/testy-a-b ',
                        variant: 'default',
                    },
                ]}
            />
            <div className="homepage containerIdosellPages">
                <Box
                    p={{ base: '20px 0', lg: '50px 0 112.5px 0' }}
                    display={'flex'}
                    flexDirection={'column'}
                    gap={'50px'}
                    position={'relative'}
                >
                    <Box>
                        <Box
                            display={'flex'}
                            gap={'30px'}
                            alignItems={'center'}
                            flexDir={{ base: 'column', lg: 'row' }}
                        >
                            <Box width={{ base: '100%', lg: '50%' }}>
                                <Show above="lg">
                                    <Image
                                        src="https://www.idosell.com/panel/file-gate.php?id=607799&ext=.png"
                                        alt=""
                                    ></Image>
                                </Show>
                                <Show below="lg">
                                    <Image
                                        src="https://www.idosell.com/panel/file-gate.php?id=607800&ext=.png"
                                        alt=""
                                    ></Image>
                                </Show>
                            </Box>
                            <Box width={{ base: '100%', lg: '50%' }} padding={'30ox'}>
                                <Text
                                    fontSize={'34px'}
                                    lineHeight={'1.5'}
                                    fontWeight={'600'}
                                    color={'#1AAC7A'}
                                    mb="30px"
                                >
                                    Sprawdź, jak testy A/B mogą zwiększyć Twoje zyski
                                </Text>
                                <List
                                    spacing={'15px'}
                                    fontSize={'18px'}
                                    lineHeight={'27px'}
                                    color={'#171717'}
                                >
                                    <ListItem display={'flex'}>
                                        <Box mr={'30px'} mt={'5px'}>
                                            <svg
                                                width="20"
                                                height="26"
                                                viewBox="0 0 20 26"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <g clip-path="url(#clip0_8_2627)">
                                                    <path
                                                        fill-rule="evenodd"
                                                        clip-rule="evenodd"
                                                        d="M12 12.5V5.5H9L9 12.5H2V15.5H9L9 22.5H12V15.5H19V12.5H12Z"
                                                        fill="#1AAC7A"
                                                    />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_8_2627">
                                                        <rect
                                                            width="20"
                                                            height="20"
                                                            fill="white"
                                                            transform="translate(0 5.5)"
                                                        />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </Box>

                                        <Box>
                                            <Text
                                                color={''}
                                                fontSize={'21px'}
                                                lineHeight={'1.5'}
                                                fontWeight={'600'}
                                                mb="5px"
                                            >
                                                Personalizacja funkcji sklepu
                                            </Text>
                                            <Text fontSize={'16px'} lineHeight={'1.5'} mb="5px">
                                                Dzięki integracji aplikacji z panelem IdoSell
                                                zyskujesz możliwość dostosowania sklepu do własnych
                                                potrzeb.
                                            </Text>
                                        </Box>
                                    </ListItem>
                                    <ListItem display={'flex'}>
                                        <Box mr={'30px'} mt={'5px'}>
                                            <svg
                                                width="20"
                                                height="26"
                                                viewBox="0 0 20 26"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <g clip-path="url(#clip0_8_2627)">
                                                    <path
                                                        fill-rule="evenodd"
                                                        clip-rule="evenodd"
                                                        d="M12 12.5V5.5H9L9 12.5H2V15.5H9L9 22.5H12V15.5H19V12.5H12Z"
                                                        fill="#1AAC7A"
                                                    />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_8_2627">
                                                        <rect
                                                            width="20"
                                                            height="20"
                                                            fill="white"
                                                            transform="translate(0 5.5)"
                                                        />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </Box>
                                        <Box>
                                            <Text
                                                fontSize={'21px'}
                                                lineHeight={'1.5'}
                                                fontWeight={'600'}
                                                mb="5px"
                                            >
                                                Większa sprzedaż
                                            </Text>
                                            <Text fontSize={'16px'} lineHeight={'1.5'} mb="5px">
                                                Testuj różne wersje przycisków, nagłówków, opisów
                                                produktów czy układu strony i wybierz tę, która
                                                sprzedaje najwięcej
                                            </Text>
                                        </Box>
                                    </ListItem>
                                    <ListItem display={'flex'}>
                                        <Box mr={'30px'} mt={'5px'}>
                                            <svg
                                                width="20"
                                                height="26"
                                                viewBox="0 0 20 26"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <g clip-path="url(#clip0_8_2627)">
                                                    <path
                                                        fill-rule="evenodd"
                                                        clip-rule="evenodd"
                                                        d="M12 12.5V5.5H9L9 12.5H2V15.5H9L9 22.5H12V15.5H19V12.5H12Z"
                                                        fill="#1AAC7A"
                                                    />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_8_2627">
                                                        <rect
                                                            width="20"
                                                            height="20"
                                                            fill="white"
                                                            transform="translate(0 5.5)"
                                                        />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </Box>
                                        <Box>
                                            <Text
                                                fontSize={'21px'}
                                                lineHeight={'1.5'}
                                                fontWeight={'600'}
                                                mb="5px"
                                            >
                                                Bezpieczne zmiany
                                            </Text>
                                            <Text fontSize={'16px'} lineHeight={'1.5'} mb="5px">
                                                Sprawdzaj nowe rozwiązania na małej grupie
                                                użytkowników, minimalizując ryzyko
                                            </Text>
                                        </Box>
                                    </ListItem>
                                    <ListItem display={'flex'}>
                                        <Box mr={'30px'} mt={'5px'}>
                                            <svg
                                                width="20"
                                                height="26"
                                                viewBox="0 0 20 26"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <g clip-path="url(#clip0_8_2627)">
                                                    <path
                                                        fill-rule="evenodd"
                                                        clip-rule="evenodd"
                                                        d="M12 12.5V5.5H9L9 12.5H2V15.5H9L9 22.5H12V15.5H19V12.5H12Z"
                                                        fill="#1AAC7A"
                                                    />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_8_2627">
                                                        <rect
                                                            width="20"
                                                            height="20"
                                                            fill="white"
                                                            transform="translate(0 5.5)"
                                                        />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </Box>
                                        <Box>
                                            <Text
                                                fontSize={'21px'}
                                                lineHeight={'1.5'}
                                                fontWeight={'600'}
                                                mb="5px"
                                            >
                                                Większe zaangażowanie
                                            </Text>
                                            <Text fontSize={'16px'} lineHeight={'1.5'} mb="5px">
                                                Testuj CTA i pop-upy i wybierz te, które generują
                                                więcej kliknięć i sprzedaży
                                            </Text>
                                        </Box>
                                    </ListItem>
                                    <ListItem display={'flex'}>
                                        <Box mr={'30px'} mt={'5px'}>
                                            <svg
                                                width="20"
                                                height="26"
                                                viewBox="0 0 20 26"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <g clip-path="url(#clip0_8_2627)">
                                                    <path
                                                        fill-rule="evenodd"
                                                        clip-rule="evenodd"
                                                        d="M12 12.5V5.5H9L9 12.5H2V15.5H9L9 22.5H12V15.5H19V12.5H12Z"
                                                        fill="#1AAC7A"
                                                    />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_8_2627">
                                                        <rect
                                                            width="20"
                                                            height="20"
                                                            fill="white"
                                                            transform="translate(0 5.5)"
                                                        />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </Box>
                                        <Box>
                                            <Text
                                                fontSize={'21px'}
                                                lineHeight={'1.5'}
                                                fontWeight={'600'}
                                                mb="5px"
                                            >
                                                Lepsze zrozumienie klientów
                                            </Text>
                                            <Text fontSize={'16px'} lineHeight={'1.5'} mb="5px">
                                                Analizuj, które elementy przyciągają kupujących, a
                                                które powodują porzucenia koszyka
                                            </Text>
                                        </Box>
                                    </ListItem>
                                    <ListItem display={'flex'}>
                                        <Box mr={'30px'} mt={'5px'}>
                                            <svg
                                                width="20"
                                                height="26"
                                                viewBox="0 0 20 26"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <g clip-path="url(#clip0_8_2627)">
                                                    <path
                                                        fill-rule="evenodd"
                                                        clip-rule="evenodd"
                                                        d="M12 12.5V5.5H9L9 12.5H2V15.5H9L9 22.5H12V15.5H19V12.5H12Z"
                                                        fill="#1AAC7A"
                                                    />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_8_2627">
                                                        <rect
                                                            width="20"
                                                            height="20"
                                                            fill="white"
                                                            transform="translate(0 5.5)"
                                                        />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </Box>
                                        <Box>
                                            <Text
                                                fontSize={'21px'}
                                                lineHeight={'1.5'}
                                                fontWeight={'600'}
                                                mb="5px"
                                            >
                                                Trafne decyzje marketingowe
                                            </Text>
                                            <Text fontSize={'16px'} lineHeight={'1.5'} mb="5px">
                                                Sprawdzaj skuteczność banerów i reklam na podstawie
                                                danych, nie przypuszczeń
                                            </Text>
                                        </Box>
                                    </ListItem>
                                    <ListItem display={'flex'}>
                                        <Box mr={'30px'} mt={'5px'}>
                                            <svg
                                                width="20"
                                                height="26"
                                                viewBox="0 0 20 26"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <g clip-path="url(#clip0_8_2627)">
                                                    <path
                                                        fill-rule="evenodd"
                                                        clip-rule="evenodd"
                                                        d="M12 12.5V5.5H9L9 12.5H2V15.5H9L9 22.5H12V15.5H19V12.5H12Z"
                                                        fill="#1AAC7A"
                                                    />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_8_2627">
                                                        <rect
                                                            width="20"
                                                            height="20"
                                                            fill="white"
                                                            transform="translate(0 5.5)"
                                                        />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </Box>
                                        <Box>
                                            <Text
                                                fontSize={'21px'}
                                                lineHeight={'1.5'}
                                                fontWeight={'600'}
                                                mb="5px"
                                            >
                                                Ciągła optymalizacja
                                            </Text>
                                            <Text fontSize={'16px'} lineHeight={'1.5'} mb="5px">
                                                Dopasuj sklep do oczekiwań klientów i zwiększaj jego
                                                efektywność
                                            </Text>
                                        </Box>
                                    </ListItem>
                                </List>
                            </Box>
                        </Box>
                    </Box>
                </Box>
                <Flex flexDirection={'column'}>
                    <Flex flexDir={'column'} gap={'10px'} alignItems={'center'}>
                        <Heading
                            as="h2"
                            fontSize={{ base: '34px', md: '34px' }}
                            lineHeight={{ base: '37px', md: '48px' }}
                            color={'#424242'}
                        >
                            Jak działa moduł testów A/B w IdoSell?
                        </Heading>
                        <Text textAlign={'center'} fontSize={'18px'} lineHeight={'27px'}>
                            Testowanie zmian w sklepie nigdy nie było takie proste. Z modułem testów
                            A/B w IdoSell w kilku krokach sprawdzisz, które rozwiązanie przynosi
                            lepsze efekty:
                        </Text>
                    </Flex>
                    <Grid templateColumns={'1fr 1fr'} gap={'30px'} py={'50px'}>
                        <Flex gap={'15px'}>
                            <Box padding={'15px 15px 0 15px'}>
                                <svg
                                    width="14"
                                    height="41"
                                    viewBox="0 0 14 41"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M0.944 7.79995V0.833949H13.958V40.2H6.182V7.79995H0.944Z"
                                        fill="#1AAC7A"
                                    />
                                </svg>
                            </Box>
                            <Box flex={'1'} gap="20px">
                                <Text fontSize={'21px'} fontWeight="semibold" p={'23px 0 23px 0'}>
                                    Stwórz nowy wariant
                                </Text>
                                <Text fontSize={'16px'}>
                                    Utwórz nowy wariant szablonu w narzędziu Composer, zmień proces
                                    zakupowy lub dostosuj politykę cenową.
                                </Text>
                            </Box>
                        </Flex>
                        <Flex gap={'15px'}>
                            <Box padding={'15px 15px 0 15px'}>
                                <svg
                                    width="28"
                                    height="41"
                                    viewBox="0 0 28 41"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M3.238 32.668C6.694 29.788 9.448 27.394 11.5 25.486C13.552 23.5419 15.262 21.5259 16.63 19.4379C17.998 17.3499 18.682 15.2979 18.682 13.282C18.682 11.446 18.25 10.006 17.386 8.96195C16.522 7.91795 15.19 7.39595 13.39 7.39595C11.59 7.39595 10.204 8.00795 9.232 9.23195C8.26 10.42 7.756 12.0579 7.72 14.1459H0.376C0.52 9.82595 1.798 6.54995 4.21 4.31795C6.658 2.08595 9.754 0.969948 13.498 0.969948C17.602 0.969948 20.752 2.06795 22.948 4.26395C25.144 6.42395 26.242 9.28595 26.242 12.8499C26.242 15.6579 25.486 18.3399 23.974 20.896C22.462 23.452 20.734 25.684 18.79 27.592C16.846 29.464 14.308 31.732 11.176 34.396H27.106V40.66H0.43V35.044L3.238 32.668Z"
                                        fill="#1AAC7A"
                                    />
                                </svg>
                            </Box>
                            <Box flex={'1'}>
                                <Text fontSize={'21px'} fontWeight="semibold" p={'23px 0 23px 0'}>
                                    Zdecyduj, co testujesz
                                </Text>
                                <Text>Sprawdzaj różne wersje strony, checkoutu czy oferty</Text>
                            </Box>
                        </Flex>
                        <Flex gap={'15px'}>
                            <Box padding={'15px 15px 0 15px'}>
                                <svg
                                    width="28"
                                    height="42"
                                    viewBox="0 0 28 42"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M0.97 12.202C1.15 8.60195 2.41 5.82995 4.75 3.88595C7.126 1.90595 10.24 0.915948 14.092 0.915948C16.72 0.915948 18.97 1.38395 20.842 2.31995C22.714 3.21995 24.118 4.46195 25.054 6.04595C26.026 7.59395 26.512 9.35795 26.512 11.3379C26.512 13.606 25.918 15.532 24.73 17.116C23.578 18.664 22.192 19.7079 20.572 20.248V20.464C22.66 21.112 24.28 22.2639 25.432 23.9199C26.62 25.576 27.214 27.7 27.214 30.292C27.214 32.452 26.71 34.378 25.702 36.07C24.73 37.762 23.272 39.094 21.328 40.066C19.42 41.002 17.116 41.47 14.416 41.47C10.348 41.47 7.036 40.444 4.48 38.392C1.924 36.34 0.574 33.316 0.43 29.32H7.774C7.846 31.084 8.44 32.506 9.556 33.586C10.708 34.63 12.274 35.152 14.254 35.152C16.09 35.152 17.494 34.648 18.466 33.64C19.474 32.596 19.978 31.264 19.978 29.644C19.978 27.484 19.294 25.936 17.926 25C16.558 24.064 14.434 23.596 11.554 23.596H9.988V17.386H11.554C16.666 17.386 19.222 15.676 19.222 12.256C19.222 10.7079 18.754 9.50195 17.818 8.63795C16.918 7.77395 15.604 7.34195 13.876 7.34195C12.184 7.34195 10.87 7.80995 9.934 8.74595C9.034 9.64595 8.512 10.7979 8.368 12.202H0.97Z"
                                        fill="#1AAC7A"
                                    />
                                </svg>
                            </Box>
                            <Box flex={'1'}>
                                <Text fontSize={'21px'} fontWeight="semibold" p={'23px 0 23px 0'}>
                                    System losowo dzieli użytkowników:
                                </Text>
                                <Box alignItems={'center'} display={'flex'}>
                                    <svg
                                        width="9"
                                        height="10"
                                        viewBox="0 0 9 10"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <rect y="0.199951" width="9" height="9" fill="#171717" />
                                    </svg>
                                    <Text ml={'15px'}>Grupa A widzi wersję oryginalną</Text>
                                </Box>
                                <Box alignItems={'center'} display={'flex'}>
                                    <svg
                                        width="9"
                                        height="10"
                                        viewBox="0 0 9 10"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <rect y="0.199951" width="9" height="9" fill="#171717" />
                                    </svg>
                                    <Text ml={'15px'}>Grupa B widzi wersję zmienioną</Text>
                                </Box>
                            </Box>
                        </Flex>
                        <Flex gap={'15px'}>
                            <Box padding={'15px 15px 0 15px'}>
                                <svg
                                    width="32"
                                    height="40"
                                    viewBox="0 0 32 40"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M0.538 31.532V25.592L18.196 0.31995H26.998V24.944H31.75V31.532H26.998V39.2H19.438V31.532H0.538ZM19.924 8.41995L8.854 24.944H19.924V8.41995Z"
                                        fill="#1AAC7A"
                                    />
                                </svg>
                            </Box>
                            <Box flex={'1'}>
                                <Text fontSize={'21px'} fontWeight="semibold" p={'23px 0 23px 0'}>
                                    Analizuj wyniki
                                </Text>
                                <Text>
                                    Wdrażaj najlepsze rozwiązanie – a jeśli chcesz, testuj kolejne
                                    warianty, by stale optymalizować sklep.
                                </Text>
                            </Box>
                        </Flex>
                    </Grid>
                    <Flex alignItems={'center'} justifyContent={'center'} flexDirection={'column'}>
                        <Link
                            href="https://www.idosell.com/pl/composer/"
                            background={'#171717'}
                            color={'white'}
                            padding={'12px 30px'}
                            fontSize={'16px'}
                            fontWeight={'600'}
                            display={'flex'}
                            alignItems={'center'}
                            gap={'10px'}
                            target="_blank"
                            _hover={{
                                underline: 'none',
                                background: 'rgba(11, 113, 83, 0.5)',
                            }}
                        >
                            Composer w IdoSell
                            <svg
                                width="9"
                                height="14"
                                viewBox="0 0 9 14"
                                fill="white"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M0 13.6H2.70588L8.4 6.98565L2.70588 0.400024H0L5.69412 6.98565L0 13.6Z" />
                            </svg>
                        </Link>
                    </Flex>
                </Flex>
                <TilesSection
                    title={
                        'Testuj, analizuj, optymalizuj i zwiększaj sprzedaż z modułem testów A/B w IdoSell'
                    }
                    subtitle="Dobre praktyki testów A/B – wskazówki ekspertów IdoSell"
                    tiles={[
                        {
                            title: 'Formułuj precyzyjne hipotezy',
                            content:
                                'Przed uruchomieniem testu określ, jaka zmiana powinna poprawić wyniki i dlaczego.',
                        },
                        {
                            title: 'Testuj jedną rzecz naraz',
                            content:
                                'Tylko wtedy dokładnie określisz, co faktycznie wpłynęło na konwersję.',
                        },
                        {
                            title: 'Daj testowi czas na wiarygodne wyniki',
                            content:
                                'Minimalny czas to 1 tydzień, optymalny okres to 2–4 tygodnie. Unikaj testów trwających miesiącami – zbyt wiele czynników zewnętrznych może zaburzyć wyniki.',
                        },
                        {
                            title: 'Analizuj dane',
                            content:
                                'Monitoruj wyniki i wyciągaj wnioski, by unikać tych samych błędów w przyszłości.',
                        },
                        {
                            title: 'Nie zniechęcaj się',
                            content:
                                'Nawet jeśli test nie da oczekiwanych rezultatów, to cenna lekcja. Udoskonal zmianę i testuj ponownie!',
                        },
                        {
                            title: 'Ciesz się większą konwersją',
                            content:
                                'Testuj, analizuj i optymalizuj – dzięki temu Twój sklep będzie działał sprawniej i skuteczniej zwiększał sprzedaż.',
                        },
                    ]}
                />
                <SectionWithPlusTick
                    alignItems={'center'}
                    display={'flex'}
                    flexDirection={'column'}
                    background={'#1AAC7A'}
                    p={'50px 0'}
                    image={{
                        url: 'https://www.idosell.com/panel/file-gate.php?id=607801&ext=.webp',

                        alt: 'Zdjęcie Pani z założonymi rękami',
                    }}
                    tickItem={[
                        {
                            title: 'Elementy szablonu – przyciski, nagłówki, CTA, układ strony',
                        },
                        {
                            title: 'Proces zakupowy – alternatywne ścieżki finalizacji zamówienia',
                        },
                        {
                            title: 'Rekomendacje produktowe  i strategie cenowe – sprawdzaj, które generują więcej sprzedaży',
                        },
                        {
                            title: 'Strategie cenowe – różne modele rabatowe i promocje',
                        },
                    ]}
                />
                <Box p={{ base: '20px 0', lg: '50px 0 100px 0' }}>
                    <Flex flexDirection={'column'}>
                        <Text
                            fontSize={{ base: '30px', md: '34px' }}
                            lineHeight={'1.5'}
                            fontWeight={'600'}
                            color={'#171717'}
                            as="b"
                            textAlign="center"
                            marginBottom={'10px'}
                        >
                            Jak bezpiecznie rozwijać sprzedaż w e-sklepie? <br /> Rola testów A/B w
                            e-commerce
                        </Text>
                        <Text
                            fontSize="18px"
                            color={'#171717'}
                            fontWeight={'400'}
                            mb="5px"
                            textAlign="center"
                            marginBottom={'60px'}
                        >
                            Testy A/B są kluczowym narzędziem pozwalającym na zrozumienie, które
                            zmiany w interfejsie i funkcjonalnościach prowadzą do wyższej konwersji
                            i lepszego doświadczenia użytkownika
                        </Text>
                    </Flex>
                    <Flex
                        gap={{ base: '0', md: '30px' }}
                        flexDirection={{ base: 'column', lg: 'row' }}
                    >
                        {/* Sekcja tekstowa */}
                        <Flex
                            flexBasis={{ base: '100%', md: '370px' }}
                            maxW={{ base: '100%', md: '370px' }}
                            flexShrink={0}
                            flexDir="column"
                            p="30px"
                            bg="#1AAC7A"
                            flex="1"
                        >
                            <Text
                                mb="15px"
                                color="white"
                                fontSize={{ base: '30px', md: '34px' }}
                                fontWeight="bold"
                            >
                                Optymalizuj sprzedaż w swoim e-sklepie
                            </Text>
                            <Text fontSize="18px" color="white">
                                Obejrzyj nagranie webinaru i poznaj rolę testów A/B w e-commerce.
                                Podczas webinaru eksperci IdoSell podzielili się swoimi
                                doświadczeniami z badań przeprowadzonych m.in. w trakcie wdrażania
                                nowego Multi-Page Checkout.
                            </Text>
                        </Flex>

                        {/* Sekcja wideo */}
                        <Flex maxW={{ base: '100%', md: 'calc(100% - 370px - 30px)' }} flex="1">
                            <AspectRatio ratio={16 / 9} w="100%">
                                <iframe
                                    src="https://www.youtube.com/embed/-okAok8qnOg?si=p52QOOWNK4e79obI"
                                    title="YouTube video player"
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                    referrerPolicy="strict-origin-when-cross-origin"
                                    allowFullScreen
                                />
                            </AspectRatio>
                        </Flex>
                    </Flex>
                </Box>
                <ContactSection mb="50px" />
            </div>
        </ThemeProvider>
    );
}
